import { ArrowUpRight, Check, RotateCcw } from "lucide-react";
import { APP_URL } from "@/components/SiteNav";
import { CHIUSURA } from "@/data/simulatorCopy";

export const ResultPitch = ({ onRestart }) => (
  <div className="sim-pitch glass mt-10 rounded-2xl border p-6 sm:p-10" data-testid="sim-pitch">
    <p className="font-mono text-xs tracking-[0.25em] uppercase text-cyan">{CHIUSURA.eyebrow}</p>
    <h4 className="mt-3 font-extrabold tracking-[-0.04em] leading-[1.05] text-3xl sm:text-4xl text-white" data-testid="sim-pitch-title">
      {CHIUSURA.titolo}
    </h4>
    <div className="mt-5 space-y-3 max-w-2xl text-sm sm:text-[15px] leading-relaxed text-titanium">
      {CHIUSURA.paragrafi.map((p) => <p key={p}>{p}</p>)}
    </div>
    <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-testid="sim-benefits">
      {CHIUSURA.benefici.map((b) => (
        <li key={b.titolo} className="flex gap-3 rounded-xl border border-[#1e2024] bg-black/30 p-4">
          <Check className="mt-0.5 h-4 w-4 shrink-0 text-cyan" strokeWidth={2.5} />
          <span>
            <span className="block text-sm font-bold text-white">{b.titolo}</span>
            <span className="mt-1 block text-xs sm:text-[13px] leading-relaxed text-titanium">{b.testo}</span>
          </span>
        </li>
      ))}
    </ul>
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="cta cta-mega glass mt-8 flex items-center justify-center gap-3 rounded-2xl border px-6 py-4 sm:py-5 text-center text-sm sm:text-base font-bold text-white"
      data-testid="sim-cv-cta"
    >
      {CHIUSURA.cta}
      <ArrowUpRight className="h-5 w-5 shrink-0 text-cyan" />
    </a>
    <button type="button" onClick={onRestart} className="nav-link mx-auto mt-5 flex items-center gap-2 font-mono text-xs text-titanium" data-testid="sim-restart">
      <RotateCcw className="h-3.5 w-3.5" /> {CHIUSURA.ricomincia}
    </button>
  </div>
);
